// removed by extract-text-webpack-plugin
module.exports = {"checklist":"checklist__1bOdt","checklist-item":"checklist-item__3g__V","details":"details__JMgWd","title":"title__1NvOk","tick-wrapper":"tick-wrapper__3dc-M","top-funds":"top-funds__36WAZ"};


//////////////////
// WEBPACK FOOTER
// ./styles/checklist.scss
// module id = 599
// module chunks = 68